import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { seedDb } from '../../reducers/settings'
import { getHistory } from '../../reducers/pass-list'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button';
const styles = theme => ({
  root: { flexGrow: 1 }
});
/**
 *
 */
const Settings = (props) => {
  const _seedDb = props.seedDb;
  const _getHistory = props.getHistory;
  const classes = props.classes;
  return (
    <div className={classes.root}>
      <Button onClick={_seedDb} color="primary">
        Seed DB
      </Button>
      <Button onClick={_getHistory} color="primary">
        Refresh History
      </Button>
    </div>
  );
}
Settings.propTypes = {
  classes: PropTypes.object,
  seedDb: PropTypes.func.isRequired,
  getHistory: PropTypes.func.isRequired
};

const mapStateToProps = (state, ownProps) => ({
  //TODO: Implement mapStateToProps method for Settings
})

const mapDispatchToProps = dispatch => bindActionCreators({
  seedDb,
  getHistory
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Settings));


// WEBPACK FOOTER //
// ./src/pages/settings/index.js